import axiosInstance from '../helpers/interceptor';

export const getUserProfile = async () => {
  return axiosInstance.get(`${Env.API_URL}/learning-game/user-profile`);
};

export const createOrUpdateUserRecordCollection = async (data) => {
  return axiosInstance.put(
    `${Env.API_URL}/learning-game/records/${data.collectionId}/${data.id}`,
    data
  );
};

export const updateUserRecordUsingJsonPatch = async (data) => {
  return axiosInstance.patch(
    `${Env.API_URL}/learning-game/records/${data.collectionId}/${data.id}`,
    data
  );
};

export const getUserRecord = async (data) => {
  return axiosInstance.get(
    `${Env.API_URL}/learning-game/records/${data.collectionId}/${data.id}`
  );
};

export const deleteUserRecord = async (data) => {
  return axiosInstance.delete(
    `${Env.API_URL}/learning-game/records/${data.collectionId}/${data.id}`
  );
};

export const retrieveAllRecordCollection = async (data) => {
  return axiosInstance.get(
    `${Env.API_URL}/learning-game/collections/${data.collectionId}`
  );
};

export const deleteAllRecordCollection = async (data) => {
  return axiosInstance.delete(
    `${Env.API_URL}/learning-game/collections/${data.collectionId}`
  );
};

export const embeddedContentVideo = async (data) => {
  return axiosInstance.get(
    `${Env.API_URL}/learning-game/embedded-content/${data.contentId}`
  );
};
